var __makeTemplateObject = this && this.__makeTemplateObject || function (cooked, raw) {
  if (Object.defineProperty) {
    Object.defineProperty(cooked, "raw", {
      value: raw
    });
  } else {
    cooked.raw = raw;
  }
  return cooked;
};
var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from 'react';
import styled, { css } from 'styled-components';
import { classNames } from '@shapeable/utils';
import { breakpoints, theme } from '@shapeable/theme';
import { EntitySelect } from './entity-select';
var cls = classNames('entity-grid');
export var EntityFilterSelectDefaultProps = {
  size: 'default',
  isMulti: true
};
// -------- Styles -------->
var SelectStyles = breakpoints({
  base: css(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n    font-size: ", ";\n    font-family: ", ";\n  "], ["\n    font-size: ", ";\n    font-family: ", ";\n  "])), theme.FONT_SIZE(14), theme.FONT('sans'))
});
// -------- Components -------->
var My = {
  Select: styled(EntitySelect)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["", ""], ["", ""])), SelectStyles)
};
export var EntityFilterSelect = function (props) {
  var isClearable = props.isClearable === undefined ? props.size === 'slim' : props.isClearable;
  return React.createElement(My.Select, __assign({
    _variant: props.size
  }, props, {
    isClearable: isClearable,
    showSearchIcon: false
  }));
};
EntityFilterSelect.defaultProps = EntityFilterSelectDefaultProps;
EntityFilterSelect.cls = cls;
var templateObject_1, templateObject_2;